import { render, staticRenderFns } from "./spaceUserData.vue?vue&type=template&id=40f7deaa&scoped=true&"
import script from "./spaceUserData.vue?vue&type=script&lang=js&"
export * from "./spaceUserData.vue?vue&type=script&lang=js&"
import style0 from "./spaceUserData.vue?vue&type=style&index=0&id=40f7deaa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40f7deaa",
  null
  
)

export default component.exports